import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'pairs',
  standalone: true,
  pure: true
})
export class PairsPipe implements PipeTransform {
  transform<T extends Record<string, any>>(obj: T | null | undefined): { key: string; value: T[keyof T] }[] {
    if (!obj || typeof obj !== 'object') return [];

    return Object.keys(obj).map(key => ({
      key,
      value: obj[key]
    }));
  }
}
